/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-new */
/* eslint-disable semi */
/* eslint-disable indent */
/* eslint-disable padded-blocks */
/* eslint-disable space-before-function-paren */
/* eslint-disable-next-line */
import Vue from 'vue'
import Vuex from 'vuex'
import {
  HTTP
} from '../http-common'

Vue.use(Vuex)
const AUTH_TOKEN = 'Bearer 123.hello'
HTTP.defaults.headers.common['Authorization'] = AUTH_TOKEN

export const store = new Vuex.Store({
  state: {
    /* USER */
    user: {},
    loadedAccounts: [],
    /* PLANS */
    loadedPlans: null,
    selectedPlan: null,
    selectedPlanCode: null,
    selectedPhone: null,
    phoneNumbers: null,
    /* GENERAL */
    isFinished: false,
    sim: null,
    agent: null,
    error: null,
    loading: false
  },

  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    setError(state, payload) {
      state.error = payload
    },
    clearError(state) {
      state.error = null
    },

    /* USER */
    setAccountId(state, payload) {
      state.user.accountId = payload
    },
    setUser(state, payload) {
      state.user = payload
    },
    setLoadedAccounts(state, payload) {
      state.loadedAccounts = payload
    },
    clearSession(state) {
      state.user = {}
      state.isFinished = null
      state.loadedAccounts = []
      state.loadedPlans = null
      state.phoneNumbers = null
      state.selectedPlan = null
      state.selectedPlanCode = null
      state.selectedPhone = null
      state.sim = null
      state.agent = null
    },

    clearDetails(state) {
      state.isFinished = null
      state.loadedAccounts = []
      state.loadedPlans = null
      state.phoneNumbers = null
      state.selectedPlan = null
      state.selectedPlanCode = null
      state.selectedPhone = null
      state.sim = null
      state.agent = null
    },

    /* PLANS */
    setLoadedPlans(state, payload) {
      state.loadedPlans = payload
    },
    setSelectedPlanCode(state, payload) {
      state.selectedPlanCode = payload.code
    },
    setSelectedPlan(state, payload) {
      state.selectedPlan = payload.plan
    },

    /* PHONE NUMBERS */
    setPhoneNumbers(state, payload) {
      state.phoneNumbers = payload
    },

    setSelectedPhone(state, payload) {
      state.selectedPhone = payload
    },

    /* PIN VERIFICATION */
    setSIM(state, payload) {
      state.sim = payload
    },

    setAgent(state, payload) {
      state.agent = payload
    },

    setFinished(state, payload) {
      state.isFinished = payload
    },

    activateAdditionalSIM(state) {
      state.loadedPlans = null
      state.selectedPlan = null
      state.selectedPlanCode = null
      state.selectedPhone = null
      state.phoneNumbers = null
      state.isFinished = false
      state.sim = null
      state.agent = null
    }
  },

  actions: {
    clearError({
      commit
    }) {
      commit('clearError')
    },

    clearDetails({
      commit
    }) {
      commit('clearDetails')
    },

    resetSim({
      commit
    }) {
      commit('setSIM', null)
    },

    setLoading({
      commit
    }) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        resolve();
      })
    },

    /* USER */
    createUserAccount({
      commit
    }, userAccount) {
      const user = {
        contact: {
          fname: userAccount.fname,
          lname: userAccount.lname,
          address1: userAccount.address1,
          address2: userAccount.address2,
          address3: userAccount.address3,
          city: userAccount.city,
          province: userAccount.province,
          country: userAccount.country || 'CA',
          postalCode: userAccount.postalCode,
          emailAddress: userAccount.email,
          password: userAccount.password
        }
      }


      commit('setLoading', true)
      let request = HTTP.post('/signup', user)
        .then(response => {
          commit('setLoading', false)
          user.accountId = response.data.accountId
          user.taxRate = response.data.taxRate
          commit('setUser', user)
        })
        .catch(e => {
          commit('setLoading', false)
          commit('setError', e)
        })

      return request
    },

    setAccountId({
      commit
    }, accountId) {
      commit('setAccountId', accountId)
    },

    signInUser({
      commit
    }, credentials) {
      commit('setLoading', true)
      commit('clearError')
      // perform authentication request
      return HTTP.post('/login', credentials, {
          // withCredentials: true
        })
        .then(response => {

          commit('setLoading', false)
          // commit('setUser', payload)
          if (response && response.data && response.data.accounts) {
            if (response.data.accounts.length > 1) {
              commit('setLoadedAccounts', response.data.accounts)
            } else {
              commit('setUser', response.data.accounts[0])
            }
          }
        })
        .catch(e => {
          commit('setLoading', false)
          commit('setError', e)
        })
    },
    setDefaultAccount({
      commit
    }, account) {
      commit('setUser', account)
    },
    logout({
      commit
    }) {
      commit('clearSession')
    },

    /* PLANS */
    getPlans({
      commit
    }, sim) {
      commit('setLoading', true)
      HTTP.get(`/plans?sim=${sim}&timestamp=${Date.now()}`)
        .then(response => {
          commit('setLoading', false)
          commit('setLoadedPlans', response.data.plans)
        })
        .catch(e => {
          commit('setLoading', false)
          commit('setError', e)
        })
    },

    setSelectedPlanCode({
      commit
    }, payload) {
      commit('setSelectedPlanCode', payload)
    },

    setSelectedPlan({
      commit
    }, payload) {
      commit('setSelectedPlan', payload)
    },

    /* PHONE NUMBERS */
    getPhoneNumbers({
      commit
    }) {
      commit('setLoading', true)
      HTTP.get(`/telephone-numbers?timestamp=${Date.now()}`, {
          country: 'CA' // hard-coded to CANADA
        })
        .then(response => {
          commit('setLoading', false)
          commit('setPhoneNumbers', response.data)
        })
        .catch(e => {
          commit('setLoading', false)
          commit('setError', e)
        })
    },

    setSelectedPhone({
      commit
    }, payload) {
      commit('setSelectedPhone', payload)
    },

    /* BILLING */
    processOrderVerifyTelephoneNumber({
      commit,
      getters
    }, payload) {
      new Promise((resolve, reject) => {
        let data = {
          accountId: getters.user.accountId,
          contact: payload.contact,
          telephoneNumber: getters.selectedPhone.phoneNumber
        }
        commit('setLoading', true)
        HTTP.post('/order-verify-number', data)
          .then(response => {
            resolve()
          })
          .catch(e => {
            commit('setLoading', false)
            commit('setError', e)
            reject(e)
          })
      })
    },

    processOrderVerifyPlan({
      commit,
      getters
    }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          contact: payload.contact,
          planCode: getters.selectedPlanCode
        }
        commit('setLoading', true)
        HTTP.post('/order-verify-plan', data)
          .then(response => {
            resolve({
              amount: response.data.amount,
              plan: {
                billingType: response.data.plan.billingType,
                planCode: response.data.plan.planCode,
                planType: response.data.plan.planType,
                recurringCharge: response.data.plan.recurringCharge,
                flatRateTariff: response.data.plan.flatRateTariff,
                billable: response.data.plan.billable
              }
            })
          })
          .catch(e => {
            commit('setLoading', false)
            commit('setError', e)
            reject(e)
          })
      })
    },

    processOrderProcessPayment({
      commit,
      getters
    }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          accountId: getters.user.accountId,
          contact: payload.contact,
          creditCard: payload.creditCard,
          amount: payload.amount
        }
        commit('setLoading', true)
        HTTP.post('/order-process-payment', data)
          .then(response => {
            resolve(response.data.reference)
          })
          .catch(e => {
            commit('setLoading', false)
            commit('setError', e)
            reject(e)
          })
      })
    },

    processOrderUpdateMasterAccount({
      commit,
      getters
    }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          contact: payload.contact
        }
        commit('setLoading', true)
        HTTP.post('/order-update-master-account', data)
          .then(response => {
            resolve()
          })
          .catch(e => {
            commit('setLoading', false)
            commit('setError', e)
            reject(e)
          })
      })
    },

    processOrderCreateServiceAccount({
      commit,
      getters
    }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          accountId: getters.user.accountId,
          contact: payload.contact,
          planCode: getters.selectedPlanCode
        }
        if (getters.agent) {
          data.agent = getters.agent
        };

        commit('setLoading', true)
        HTTP.post('/order-create-service-account', data)
          .then(response => {
            resolve(response.data.serviceId)
          })
          .catch(e => {
            commit('setLoading', false)
            commit('setError', e)
            reject(e)
          })
      })
    },

    processOrderUpdateServiceAccount({
      commit,
      getters
    }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          accountId: getters.user.accountId,
          serviceId: payload.serviceId
        }
        commit('setLoading', true)
        HTTP.post('/order-update-service-account', data)
          .then(response => {
            resolve()
          })
          .catch(e => {
            commit('setLoading', false)
            commit('setError', e)
            reject(e)
          })
      })
    },

    processOrderAssignTelephoneNumber({
      commit,
      getters
    }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          contact: payload.contact,
          accountId: getters.user.accountId,
          serviceId: payload.serviceId,
          telephoneNumber: getters.selectedPhone.phoneNumber
        }
        commit('setLoading', true)
        HTTP.post('/order-assign-number', data)
          .then(response => {
            resolve()
          })
          .catch(e => {
            commit('setLoading', false)
            commit('setError', e)
            reject(e)
          })
      })
    },

    processOrderAssignSIM({
      commit,
      getters
    }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          contact: payload.contact,
          accountId: getters.user.accountId,
          serviceId: payload.serviceId,
          sim: getters.sim
        }
        commit('setLoading', true)
        HTTP.post('/order-assign-sim', data)
          .then(response => {
            resolve()
          })
          .catch(e => {
            commit('setLoading', false)
            commit('setError', e)
            reject(e)
          })
      })
    },

    processOrderRecordPayment({
      commit,
      getters
    }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          serviceId: payload.serviceId,
          contact: payload.contact,
          amount: payload.amount,
          reference: payload.reference
        }
        commit('setLoading', true)
        HTTP.post('/order-record-payment', data)
          .then(response => {
            resolve()
          })
          .catch(e => {
            commit('setLoading', false)
            commit('setError', e)
            reject(e)
          })
      })
    },

    processOrderSetupAutomaticPayments({
      commit,
      getters
    }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          serviceId: payload.serviceId,
          contact: payload.contact,
          creditCard: payload.creditCard,
          amount: payload.amount
        }
        commit('setLoading', true)
        HTTP.post('/order-setup-auto-payments', data)
          .then(response => {
            resolve()
          })
          .catch(e => {
            commit('setLoading', false)
            commit('setError', e)
            reject(e)
          })
      })
    },

    processOrderSendConfirmation({
      commit,
      getters
    }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          planType: payload.plan.planType,
          recurringCharge: payload.plan.recurringCharge,
          serviceId: payload.serviceId,
          contact: payload.contact,
          sim: getters.sim,
          telephoneNumber: getters.selectedPhone.phoneNumber,
          planCode: getters.selectedPlanCode
        }
        commit('setLoading', true)
        HTTP.post('/order-send-confirmation', data)
          .then(response => {
            // commit('setLoading', false)
            // commit('setFinished', true)
            resolve()
          })
          .catch(e => {
            commit('setLoading', false)
            commit('setError', e)
            reject(e)
          })
      })
    },

    completeOrder({
      commit
    }) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('setLoading', false)
          commit('setFinished', true)
          resolve()
        }, 1500);
      })
    },

    logOrderError({
      commit
    }, req) {
      commit('setLoading', false)
      commit('setError', req.error)
      req.error = req.error.response.data.error
      return new Promise((resolve, reject) => {
        req.data.sim = this.getters.sim;
        req.data.telephoneNumber = this.getters.selectedPhone.phoneNumber;
        req.data.accountId = this.getters.user.accountId;
        HTTP.post(`/order-log-error`, req)
          .then(resolve)
          .catch(reject)
      })
    },

    /* PIN VERIFICATION */
    verifyPin({
      commit
    }, pin) {
      commit('setLoading', true)
      HTTP.get(`/validate-sim/${pin}?timestamp=${Date.now()}`)
        .then(response => {
          commit('setLoading', false)
          commit('setSIM', response.data.sim)
          commit('setAgent', response.data.agent)
        })
        .catch(e => {
          commit('setLoading', false)
          commit('setError', e)
        })
    },

    activateAdditionalSIM({
      commit
    }) {

      commit('activateAdditionalSIM')

    },

    visitMyAccount({
      commit
    }) {

      // commit('visitMyAccount')

      window.location.href = 'https://www.icewireless.com/login'
    }

  },

  getters: {
    loading: state => state.loading,
    error: state => state.error,

    /* USER */
    accountId(state) {
      if (!state.user) return null
      return Object.keys(state.user).length > 0 ? state.user.accountId : null
    },
    user(state) {
      if (!state.user) return null
      return Object.keys(state.user).length > 0 ? state.user : null
    },
    accounts: state => state.loadedAccounts,

    /* PLANS */
    loadedPlans: state => state.loadedPlans,
    selectedPlan: state => state.selectedPlan,
    selectedPlanCode: state => state.selectedPlanCode,

    /* PHONE NUMBERS */
    phoneNumbers: state => state.phoneNumbers,
    selectedPhone: state => state.selectedPhone,

    /* SIM */
    sim: state => state.sim,

    /* AGENT */
    agent: state => state.agent,

    taxRate(state) {
      if (!state.user) return 0
      return (state.user.taxRate / 100) // return back as a percentage
    },
    isFinished: state => state.isFinished
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js